import { Typography } from '@jisr-hr/ds'
import { Flex } from '@jisr-hr/ds-beta'
import { useTranslation } from 'react-i18next'
import { EMOJIS } from '../../constants'

export type TRadioWithContentOption = {
  label: string
  value: string | number | boolean
  testId?: string
}

type TRadioWithContent = {
  value: string | undefined
  handleChange: (text: string) => void
}

export function EmojiChoiceAnswers({ value, handleChange }: TRadioWithContent) {
  const { t } = useTranslation()

  return (
    <>
      <Flex
        dir="row"
        className="gap-6"
      >
        {EMOJIS.map((emoji) => {
          const selected = emoji.value?.toString() === value?.toString()
          return (
            <div
              aria-label={t(emoji.label)}
              key={emoji.value}
              onClick={() => handleChange(emoji.value)}
              role="radio"
              aria-checked={selected}
              tabIndex={0}
              className={`w-[100px] h-[100px] flex flex-col items-center justify-center gap-2 rounded-sm cursor-pointer hover:bg-color-bg-neutral-lightest-hovered ${
                selected ? 'shadow-md bg-color-bg-neutral-lightest-pressed' : ''
              }`}
            >
              <Typography
                variant="interface/medium/l"
                text={emoji.emoji}
              />
              <Typography
                text={t(emoji.label)}
                variant="interface/medium/sm"
                className="text-center"
              />
            </div>
          )
        })}
      </Flex>
    </>
  )
}
